<template>
  <div class="container" >
    <headerview></headerview>
    <transition name="vides">
      <div class="head-video" @click="videos = false" v-if="videos">
        <div class="videos">
          <video id="videos" @click.stop="videos = true" controls="controls" loop="loop" autoplay="autoplay" src="../assets/video/x.mp4"></video>
        </div>
      </div>
    </transition>
    <ul id="menu">
        <li :class="{'active': menushow == 0}" @click="top1"><p></p><span>Top</span></li>
        <li :class="{'active': menushow == 1}" @click="top2"><p></p><span>Service</span></li>
        <li :class="{'active': menushow == 2}" @click="top3"><p></p><span>News</span></li>
        <li :class="{'active': menushow == 3}" @click="top4"><p></p><span>Product</span></li>
        <li :class="{'active': menushow == 4}" @click="top5"><p></p><span>Application</span></li>
        <li :class="{'active': menushow == 5}" @click="top6"><p></p><span>Example</span></li>
        <li :class="{'active': menushow == 6}" @click="top7"><p></p><span>Footer</span></li>
    </ul>

    <full-page :options="options"  ref="fullpage">
      <div class="section section1">
        <div class="img-control">
          <ul>
            <li @click="imgTo1" :class="{'imgThis': bgshow1==0}"></li>
            <li @click="imgTo2" :class="{'imgThis': bgshow1==1}"></li>
            <li @click="imgTo3" :class="{'imgThis': bgshow1==2}"></li>
            <li @click="imgTo4" :class="{'imgThis': bgshow1==3}"></li>
			<li @click="imgTo5" :class="{'imgThis': bgshow1==4}"></li>
			<li @click="imgTo6" :class="{'imgThis': bgshow1==5}"></li>
          </ul>
        </div>
        <transition name="img">
          <div v-show="bgshow1==0" class="s1-bg">
            <div class="section_word section_word4">
              <h1>让AI赋能未来，让数据创造价值</h1>
              <p class="en">Empower the future with AI, let data create value</p>
              <p class="zh">以创新理念、智能技术与行业深耕，加速AI驱动的数字化升级，赋能未来！</p>
              <div class="margin" @click="videos = true"><span>观看视频</span><div><img src="../assets/images/sanj.png" alt=""></div></div>
            </div>
          </div>
        </transition>
        <transition name="img">
          <div v-show="bgshow1==1" class="s1-bg">
            <div class="section_word section_word1">
              <h1>中天亿信</h1>
              <h2>AI+大数据驱动的智能化创新解决方案引领者</h2>
              <p class="en">A leader in AI and Big Data-driven intelligent innovation solutions</p>
              <p class="zh">通过先进的人工智能与大数据技术，为企业提供高效、精准的智能化解决方案</p>
			  <p class="zh">助力行业创新与转型。</p>
              <div @click="videos = true"><span>观看视频</span><div><img src="../assets/images/sanj.png" alt=""></div></div>
            </div>
          </div>
        </transition>
        <transition name="img">
          <div v-show="bgshow1==2" class="s1-bg">
            <div class="section_word section_word1">
              <h1>AI 增强的互联网创新服务</h1>
              <p class="en">AI-enhanced Internet Innovation Service</p>
			  <p class="zh">借变革之力，乘想象之翼，创机遇之门，开启企业转型之旅。</p>
              <router-link :to="{path: '/support.html'}">
                <div><span>在线咨询</span><img src="../assets/images/greensj.png" alt=""></div>
              </router-link>
            </div>
          </div>
        </transition>
        <transition name="img">
          <div v-show="bgshow1==3" class="s1-bg">
            <div class="section_word section_word1">
              <h1>亿信云：高性能计算服务</h1>
              <p class="en">ZTYS-Ixcloud：High-Performance Computing Services</p>
              <p class="zh">依托云原生技术栈和 AI 智能调度引擎，将云原生架构、边缘计算与 AI 技术深度</p>
              <p class="zh">融合，打造面向未来的智能算力基础设施平台。</p>
              <router-link :to="{path: '/support.html'}">
                <div><span>申请试用</span><img src="../assets/images/greensj.png" alt=""></div>
              </router-link>
            </div>
          </div>
        </transition>
		<transition name="img">
          <div v-show="bgshow1==4" class="s1-bg">
            <div class="section_word section_word1">
              <h1>AI + 智慧城市解决方案</h1>
              <p class="en">AI + Smart City Solutions</p>
			  <p class="zh">为城市管理者提供全方位的智能化解决方案，助力城市治理更高效、更智能。</p>
              <router-link :to="{path: '/support.html'}">
                <div><span>在线咨询</span><img src="../assets/images/greensj.png" alt=""></div>
              </router-link>
            </div>
          </div>
        </transition>
		<transition name="img">
          <div v-show="bgshow1==5" class="s1-bg">
            <div class="section_word section_word1">
				<h1>AI 驱动的产业升级</h1>
			    <p class="en">AI-driven Industry Upgradation</p>
			    <p class="zh">为制造业、农业、供应链等垂直行业提供产业 AI 数字化转型和下一代智能供应链</p>
				<p class="zh">解决方案，推动产业智能化升级。</p>
			    <router-link :to="{path: '/support.html'}">
					<div><span>在线咨询</span><img src="../assets/images/greensj.png" alt=""></div>
			    </router-link>
            </div>
          </div>
        </transition>
      </div>
      <div class="section section2">
        <div class="s2-swiper">
          <swiper class="swiper-container" :options="swiper_all" ref="myswiper">
            <swiper-slide>
              <div class="s2-m-con s2-m-con1">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon1.png" alt="">
                </div>
                <h1>互联网定制开发</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg1" :key="index" :to="{name: 'article', params: {
                      ch: 32,
                      id: msg.id
                    }}">
                      <li @click="toApp1(index)">{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="s2-m-con s2-m-con2">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon1.png" alt="">
                </div>
                <h1>大数据应用服务</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg2" :key="index" :to="{name: 'article', params: {
                      ch: 33,
                      id: msg.id + '.html'
                    }}">
                      <li>{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="s2-m-con s2-m-con3">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon1.png" alt="">
                </div>
                <h1>智慧城市</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg3" :key="index" :to="{name: 'article', params: {
                      ch: 34,
                      id: msg.id + '.html'
                    }}">
                      <li>{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="s2-pagination" id="s2-pagination"></div>
        </div>
        <div class="s2">
          <div class="s2-left s2-lmr" @mouseenter="videoshow = true" @mouseleave="videoshow = false">
            <transition name="video">
              <div class="video" v-if="videoshow">
                <video id="video" loop="loop" autoplay="autoplay" muted src="../assets/video/website.mp4"></video>
              </div>
            </transition>
            <transition name="section2">
              <div class="s2-left-con s2-left-con1" v-if="section2_show == true">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon1.png" alt="">
                </div>
                <h1>互联网定制开发</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg1" :key="index" :to="{name: 'article', params: {
                      ch: 32,
                      id: msg.id + '.html'
                    }}">
                      <li>{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </transition>
          </div>
          <div class="s2-middle s2-lmr" @mouseenter="videoshow1 = true" @mouseleave="videoshow1 = false">
            <transition name="video">
              <div class="video" v-if="videoshow1">
                <video id="video" loop="loop" autoplay="autoplay" muted src="../assets/video/Bigdata.mp4"></video>
              </div>
            </transition>
            <transition name="section2">
              <div class="s2-left-con s2-left-con2" v-if="section2_show == true">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon2.png" alt="">
                </div>
                <h1>大数据应用服务</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg2" :key="index" :to="{name: 'article', params: {
                      ch: 33,
                      id: msg.id + '.html'
                    }}">
                      <li>{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </transition>
          </div>
          <div class="s2-right s2-lmr" @mouseenter="videoshow2 = true" @mouseleave="videoshow2 = false">
            <transition name="video">
              <div class="video" v-if="videoshow2">
                <video id="video" loop="loop" autoplay="autoplay" muted src="../assets/video/city.mp4"></video>
              </div>
            </transition>
            <transition name="section2">
              <div class="s2-left-con s2-left-con3" v-if="section2_show == true">
                <div class="s2-icon">
                  <img src="../assets/images/s2_icon3.png" alt="">
                </div>
                <h1>智慧城市</h1>
                <div class="s2-msg">
                  <ul>
                    <router-link v-for="(msg, index) in message.msg3" :key="index" :to="{name: 'article', params: {
                      ch: 34,
                      id: msg.id + '.html'
                    }}">
                      <li>{{msg.short_title}}</li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="section section3">
        <transition name="s3_title">
          <h1 v-if="t_show">新闻中心</h1>
        </transition>
        <transition name="s3_swiper">
          <div class="swiper" v-if="swiper_show">
            <div class="line"></div>
            <swiper class="swiper-container" :options="swiperOption" ref="myswiper">
              <swiper-slide v-for="(swp, index) in swps" :key="index" >
                <router-link :to="{name: 'article', params: {
                  ch: swp.channel.id,
                  id: swp.id + '.html'
                }}">
                  <div class="swiper-con">
                    <div class="swiper-con-main">
                      <div class="swiper-img">
                        <img :src="swp.image" alt="">
                      </div>
                      <p class="swiper-time">{{swp.createtime}}</p>
                      <h3 class="swiper-title">{{swp.short_title}}</h3>
                      <p class="swiper-msg">{{swp.description}}</p>
                    </div>
                  </div>
                </router-link>
              </swiper-slide>
            </swiper>
            <div class="swiper-next"><img src="../assets/images/jt_r.png" alt=""></div>
            <div class="swiper-prev"><img src="../assets/images/jt_r.png" alt=""></div>
            <div class="s3-pagination" id="s3-pagination"></div>
            <router-link :to="{path: '/news.html'}">
              <div class="s3-more">MORE VIEW</div>
            </router-link>
           </div>
        </transition>
      </div>
      <div class="section section4">
        <transition name="s3_title">
          <h1 v-if="s4t">大数据产品</h1>
        </transition>
        <transition name="s3_swiper">
          <div v-if="s4main" class="s4-main">
            <div class="s4-submain" v-for="(item, index) in cplist" :key="index">
              <div class="s4-bottom">
                {{item.title}}
              </div>
              <div class="s4-span">
                <div class="s4-span-m">
                  <div class="s4-t">{{item.title}}</div>
                  <p class="s4-msg">{{item.content}}</p>
                  <router-link :to="{name: 'article', params: {
                    id: item.id + '.html',
                    ch: 47,
                  }}">
                    <div class="s4-btn">
                      了解详情
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="s4-swiper">
          <swiper :options="s4sWiper">
            <swiper-slide v-for="(item, index) in cplist" :key="index">
              <div class="s4-submain">
                <div class="s4-span">
                  <div class="s4-span-m">
                    <div class="s4-t">{{item.title}}</div>
                    <p class="s4-msg">{{item.content}}</p>
                    <router-link :to="{name: 'article', params: {
                      id: item.id + '.html',
                      ch: 47,
                    }}">
                      <div class="s4-btn">
                        了解详情
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="s4pr-nt">
            <div class="s4nt"></div>
            <div class="s4pr"></div>
          </div>
        </div>
        <!-- <transition name="s3_swiper">
          <div v-if="s4main" @click="tocp" class="mo">MORE</div>
        </transition> -->
      </div>
      <div class="section section5">
        <transition name="s3_title">
          <div class="s5-content" v-if="s5_show">
            <div class="s5-nav">
              <li v-for="(item, index) in s5l" @click="contentShow(index)" :class="{'this-nav': item.show}">
                <p>{{item.title}}</p>
              </li>
            </div>
            <div class="s5-main">
              <div class="s5-main-l">
                <div class="s5-main-top">
                  <div class="s5-t">
                    <h1>行业应用</h1>
                    <p>大数据应用逐渐成为联网+业务的引擎，我们为您量身定制，满足各行业不同阶段的大数据解决方案需求。</p>
                  </div>
                </div>
                <div class="s5-main-bottom">
                  <transition-group tag="ul" name="fade">
                    <div class="s5-change"  v-for="(item, index) in s5l" :key="item.id" v-if="item.show">
                      <h3>{{item.name}}</h3>
                      <p class="s5c-p" v-html="item.description"></p>
                      <router-link :to="{name: 'article', params: {
                        id: item.id + '.html',
                        ch: 31,
                      }}">
                        <div class="btn1" ><span>获取方案</span><img src="../assets/images/sanjiao.png" alt=""></div>
                      </router-link>
                    </div>
                  </transition-group>
                </div>
              </div>
              <div class="s5-main-r">
                <transition-group tag="span" name="fader">
                  <div class="img" v-for="(item, index) in s5l" v-if="item.show" :key="item.id">
                    <img :src="item.image" alt="">
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </transition>
        <div class="s5-m-content">
          <div class="s5-m-title">
            <h2>行业应用</h2>
            <p>量身定制 满足各行业不同阶段的大数据需求</p>
          </div>
          <swiper :options="s5swiper">
            <swiper-slide v-for="(item, index) in s5l" :key="index">
              <div class="s5-m-con">
                <h3>{{item.title}}</h3>
                <img class="s5-img" :src="item.image" alt="">
                <div class="s5-m-msg" v-html="item.description"></div>
                <div class="s5-btn">
                  <router-link :to="{name: 'article', params: {
                    id: item.id + '.html',
                    ch: 31,
                  }}">
                    <div class="btn1"><span>了解详情</span><img src="../assets/images/sanjiao.png" alt=""></div>
                  </router-link>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="s5-pagination" id="s5-pagination"></div>
        </div>
      </div>
      <div class="section section6">
        <transition name="s3_title">
          <div class="s6-content" v-if="s6_show">
            <div class="s6-nav">
              <h1>成功案例</h1>
              <div class="sub-nav">
                <router-link :to="{path: '/example.html'}">
                  <div class="too">MORE+</div>
                </router-link>

                <!-- <ul>
                  <li v-for="(item, index) in s6list" @click="mainshow(index)">
                    <span @click="mainShow[index] = true" :class="{'span-here': mainShow[index]}">{{item.subnav}}</span>
                  </li>
                </ul> -->
              </div>
            </div>
            <div class="s6-m">
              <div class="s6-main" v-for="(it, i) in s6list" :key="i">
                <div class="s6-con"  :class="{'family-hover': mainShow[i]}" v-for="(item, index) in s6list[i].sublist" :key="index">
                  <!-- <transition name="s6_fade"> -->
                    <a target="_blank" rel="noneferrer" :href="item.tags" class="family" v-if="mainShow[i]">
                      <img class="con-img" :class="{'imghover': spanShow[index]}" :src="item.image" alt="" >
                      <span>
                        <div class="img-msg">
                          <h3>{{item.title}}</h3>
                          <!--<p>网站建设/用户体验</p>-->
                        </div>
                      </span>
                    </a>
                  <!-- </transition> -->
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="s6-m-content">
          <h2>成功案例</h2>
          <div class="s6-m-c">
            <div class="s6-m-con" v-for="item in s6list[0].sublist.slice(0,4)">
              <img :src="item.image" alt="">
            </div>
          </div>
          <div class="s6-btn">
            <router-link :to = "{path: '/example.html'}">
              <div class="too">MORE+</div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="section section7">
        <div class="tb">
          <div class="tb-span"></div>
          <div class="s7-top">
            <div class="s7-content">
              <div class="s7t-con">
                 <img src="../assets/images/ic1.png" alt="">
                 <div class="s7t-con-r">
                   <v-countup :start-value="start" :end-value="end[0]" :duration="duration"></v-countup>
                   <p>CUSTOMERS(+)</p>
                 </div>
              </div>
              <div class="s7t-con">
                 <img src="../assets/images/ic2.png" alt="">
                 <div class="s7t-con-r">
                   <v-countup :start-value="start" :end-value="end[1]" :duration="duration"></v-countup>
                   <p>CLOUD COMPUTING(GB)</p>
                 </div>
              </div>
              <div class="s7t-con">
                 <img src="../assets/images/ic3.png" alt="">
                 <div class="s7t-con-r">
                   <v-countup :start-value="start" :end-value="end[2]" :duration="duration"></v-countup>
                   <p>SUCCESS RATE(%)</p>
                 </div>
              </div>
              <div class="s7t-con">
                 <img src="../assets/images/ic4.png" alt="">
                 <div class="s7t-con-r">
                   <v-countup :start-value="start" :end-value="end[3]" :duration="duration"></v-countup>
                   <p>PROJECTS DONE</p>
                 </div>
              </div>
            </div>
          </div>
          <div class="s7t-all">
            <div class="s7t-middle">
              <h3>合作伙伴</h3>
              <div class="sub-middle">
                <div class="mid-con" v-for="(item, index) in mids">
                  <img :src="item.src" alt="">
                </div>
              </div>
            </div>
            <div class="s7t-bottom">
              <div class="bot-con">
                <router-link :to="{path: '/about.html'}">
                  <h5>关于我们</h5>
                </router-link>
                <p v-for="(item, index) in s7list[0].list">
                  <router-link :to="guanyu(index)">
                    <span>{{item.title}}</span>
                  </router-link>
                </p>
              </div>
              <div class="bot-con">
                <router-link :to="{path: '/develop.html'}">
                  <h5>产品服务</h5>
                </router-link>
                  <p v-for="(item, index) in s7list[1].list">
                    <router-link :to="todevelop(index)">
                      <span>{{item}}</span>
                    </router-link>
                  </p>
              </div>
              <div class="bot-con3">
                <router-link :to="{path: '/application.html'}">
                  <h5>行业应用</h5>
                </router-link>
                <p v-for="(item, index) in s7list[2].list">
                  <router-link :to="{name: 'article',params: {
                    id: item.id + '.html',
                    ch: 31
                  }}">
                    <span>{{item.title}}</span>
                  </router-link>
                </p>
              </div>
              <div class="bot-con bo">
                <h5 style="opacity: 0;">s</h5>
                <p v-for="(item, index) in s7list[3].list">
                  <router-link :to="{name: 'article',params: {
                    id: item.id + '.html',
                    ch: 31
                  }}">
                    <span>{{item.title}}</span>
                  </router-link>
                </p>
              </div>
              <div class="bot-con bo bo1">
                <router-link :to="art(0)">
                  <h5>新闻中心</h5>
                </router-link>
                <p v-for="(item, index) in s7list[4].list">
                  <router-link :to="art(index)">
                    <span>{{item}}</span>
                  </router-link>
                </p>
              </div>
              <div class="bot-con2">
                <h5><img src="../assets/images/wechat.png" alt="">微信公众号</h5>
                <img src="../assets/images/erweima.png" alt="" class="wechat">
              </div>
            </div>
          </div>
        </div>
        <div class="s7-footer">
          <p class="none">版权所有 湖北中天亿信科技股份有限公司</p> <p>&nbsp;Copyright © 2006-2025 ZTYS CO.,LTD.&nbsp;</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/images/police.png" alt="">鄂ICP备11017564号-2</p><p class="none">增值电信业务经营许可证编号：鄂B1、B2-20100045</p>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
import headerview from './public/header.vue'
import { news } from '../api/index.js'
import { option } from '../public/public.js'
// import fullPage from './public/fullpage.vue'
import 'wowjs/css/libs/animate.css'
export default {
  // components:{
  //   fullPage
  // },
  metaInfo: {
      title: '中天亿信—领先的AI与大数据智能化解决方案服务商|中天亿信官网',
      meta: [{ name:'viewport', content:'width=device-width, user-scalable=yes, initial-scale=1.0, maximum-scale=3.0, minimum-scale=1.0'}],
      meta: [{                 // set meta
          name: 'keyWords',
          content: '中天亿信，网站建设，网站群建设，分销平台开发，网络营销推广，政务大数据，电商大数据，智慧城市，智慧应急，智慧教育，智慧安防，云计算，企业邮箱，域名注册'
      }],
      meta: [{                 // set meta
          name: 'description',
          content: '中天亿信是领先的互联网+大数据解决方案与服务提供商，新三板上市企业、国家高新技术企业、软件企业、增值电信业务运营商，为您提供互联网平台建设、云计算、大数据以及智慧城市解决方案等服务。'
      }]
  },
  components:{
    headerview
  },
  data(){
    return {
      videos: false,
      menushow: 0,
      bgshow1: 0,
      start: 0,
      end: [0, 0, 0, 0],
      duration: 2,
      s5_show: false,
      s6_show: false,
      // fallpage参数
      options: {
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,
        scrollingSpeed: 1000,
        normalScrollElements: ".slide-main",
        fitToSection: false,
        responsiveWidth: 1200,
        anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7'],
        lockAnchors: true
      },
      // section回调参数
      section2_show: false,
      swiper_show: false,
      t_show: false,
      s4main: false,
      s4t: false,
      // swiper参数
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        autoplay: 3000,
        observer: true,
        // 修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        pagination: {
          el: '.s3-pagination',
          bulletClass: 's3-bull',
          bulletActiveClass: 's3-active'
        },
      },
      s4sWiper: {
        loop: true,
        speed: 1000,
        navigation: {
          nextEl: '.s4nt',
          prevEl: '.s4pr'
        },
      },
      swiper_all: {
        pagination: {
          el: '.s2-pagination',
          bulletClass: 's2-bull',
          bulletActiveClass: 's2-active'
        },
      },
      s5swiper:{
        pagination: {
          el: '.s5-pagination',
          bulletClass: 's5-bull',
          bulletActiveClass: 's5-active'
        },
      },
      // section4产品列表
      cplist: [{
        id: 304,
        title: "中天亿信亿信云平台",
        content: "依托云原生技术栈和AI智能调度引擎，将云原生架构、边缘计算与AI技术深度融合，构建了一套高效、灵活、安全、智能的基础设施解决方案，能够满足现代企业在云计算、人工智能、大数据等领域日益增长的需求。"
      },{
        id: 306,
        title: "中天亿信供应链管理系统",
        content: "借助实时供应链计划功能，快速响应市场变化。通过端到端的供应链可见性和对单个可信数据源的访问来推动基于事实的决策，促进更快的计划周期和一致的销售和运营计划流程，改善各职能部门之间的协作和用户参与度。"
      },{
        id: 307,
        title: "中天亿信应急指挥调度平台",
        content: "应急指挥调度平台是现代化应急管理体系的核心支撑系统，通过深度融合信息、资源与通信技术，构建“全域感知、智能研判、协同指挥、精准处置”的一体化能力，为各类突发事件的快速响应与科学处置提供全流程数字化支持，最大限度保障人民生命财产安全。"
      }],
      swps: [], //新闻列表
      // section2标签列表
      message:{
        msg1: [],
        msg2: [],
        msg3: []
      },
      // section2视频控制
      videoshow: false,
      videoshow1: false,
      videoshow2: false,

      // 第五屏列表
      s5lis: {},
      s5l: [{
	    id: 203,
        show: true,
        image: require('../assets/img/p5.png'),
        title: "亿信云平台",
        description: "<p>依托云原生技术栈和AI智能调度引擎，致力于打造面向未来的智能算力基础设施平台。该平台将云原生架构、边缘计算与AI技术深度融合，构建了一套高效、灵活、安全、智能的基础设施解决方案，能够满足现代企业在云计算、人工智能、大数据等领域日益增长的需求。</p>" 
      },{
        id: 200,
        show: false,
        image: require('../assets/img/p2.png'),
        title: "知识图谱平台",
        description: "<p>中天亿信知识图谱平台是一个集数据分析、可视化展示与智能决策支持为一体的综合数据服务平台，旨在帮助各行业用户通过图谱化方式整合、分析与挖掘海量数据，促进信息的深度融合与智慧决策。该平台通过强大的数据处理能力与先进的图谱技术，使得用户能够从复杂的数据中提取有价值的知识，实现数据驱动的业务优化和智能决策。</p>"
      },{
        id: 201,
        show: false,
        image: require('../assets/img/p3.png'),
        title: "融合通信平台",
        description: "<p>中天亿信融合通信平台是一款集多种通信功能于一体的综合管理平台，旨在提高企业和组织的沟通效率与应急响应能力，为用户的日常办公和应急处置提供强有力的通信保障。</p>"
      },{
        id: 206,
        show: false,
        image: require('../assets/img/p8.png'),
        title: "应急指挥调度平台",
        description: "<p>应急指挥调度平台是现代化应急管理体系的核心支撑系统，通过深度融合信息、资源与通信技术，构建“全域感知、智能研判、协同指挥、精准处置”的一体化能力，为自然灾害、事故灾难、公共卫生事件等各类突发事件的快速响应与科学处置提供全流程数字化支持，助力政府、企业及组织提升应急管理效能，最大限度保障人民生命财产安全。</p>"
      },{
        id: 207,
        show: false,
        image: require('../assets/img/p8.png'),
        title: "新零售系统",
        description: "<p>新零售系统整合上下游资源，发展社区团长，主要面向社区团购（客户端、团长端、供应商端、仓库端、骑手端）、外卖（商家端、骑手配送端）类型模式，系统包括前台商城平台及后台管理系统，前台商城系统包含首页门户、商品推荐、商品搜索、商品展示、购物车、订单流程、会员中心、客户服务、帮助中心等模块。后台管理系统包含商品管理、订单管理、会员管理、促销管理、运营管理、内容管理、统计报表、财务管理、管理团长、权限管理、设置等模块。</p>"
      },{
		id: 199,
        show: false,
        image: require('../assets/img/p1.png'),
        title: "政务大数据共享交换平台",
        description: "<p>电子政务公共数据开放共享平台项目建设目标是，依托统一的“云”数据中心建设统一的公共数据开放共享平台。集中机关各部门业务应用制定相关的数据规范和信息交换标准，使机关各部门业务系统依托统一的开放平台进行开发建设，确保部门之间系统之间的互联互通、数据共享，为大数据分析提供数据依据。</p><p>政务大数据共享交换平台包含：一套标准规范、两个数据门户、四大应用平台、四大基础数据库和一个应用支撑平台。</p>" 
      },{
	    id: 204,
        show: false,
        image: require('../assets/img/p6.png'),
        title: "智慧校园管理系统",
        description: "<p>以云服务为支撑，构建一个基础教育的智能化校园管理平台，以优质教育资源共建共享和应用、资源整合为中心，融入到教学、学习、管理等工作领域、最终实现提高教育质量为目标，推动教育教学改革的发展。</p><p>为广大师生提供一个全面的智能感知环境和综合信息服务平台，提供基于角色的个性化定制服务;将基于计算机网络的信息服务融入学校的各个应用与服务领域，实现互联和协作；通过智能感知环境和综合信息服务平台，为学校与外部世界提供一个相互交流和相互感知的接口。</p>"
      },{
        id: 205,
        show: false,
        image: require('../assets/img/p7.png'),
        title: "供应链管理系统",
        description: "<p>借助实时供应链计划功能，快速响应市场变化。通过端到端的供应链可见性和对单个可信数据源的访问来推动基于事实的决策，促进更快的计划周期和一致的销售和运营计划流程，改善各职能部门之间的协作和用户参与度。凭借集成的业务计划技术，推动S&OP流程，以协调所有利益相关者并在中/长期范围内试行业务，通过提高知名度和改善协作来降低成本，改善计划安全性以支持向新市场的销售，通过最大的生产能力提高效率，并为内部和外部用户更快地访问相关信息，借助SKU和运达级别的更准确，更细粒度的数据和预测来改善决策。</p>"
      },{
        id: 202,
        show: false,
        image: require('../assets/img/p3.png'),
        title: "网站（集群）内容管理系统 ",
        description: "<p>中天亿信网站（集群）内容管理系统是一款面向政府、媒体和企业等行业用户的内容管理平台，支持在云计算架构上进行集群化部署，并且支持内容管理云服务模式，为不同的、多级组织机构提供内容丰富、形式多样、可扩展的内容管理云服务，具有与社交媒体融合、一次采编/多渠道发布、碎片化发布、可视化专题制作、富媒体内容管理等功能特点,并提供整套公共微服务服务模块，集中权限管理（单点登录）、内容管理、支付中心、用户管理（支持第三方登录）、微信平台、存储系统、配置中心、日志分析、任务和通知等，支持服务治理、监控和追踪。</p>"
      },{
        id: 208,
        show: false,
        image: require('../assets/img/p10.png'),
        title: "实验室信息管理系统（LIMS）",
        description: "<p>LIMS实验室管理系统是为实验、检测等业务板块提供流程化、模块化、标准化操作管理系统，打造基于行业法规的实验室全流程质量控制管理系统，实现实验室“人、机、料、法、环”关键环节管理。</p><p>LIMS管理过程实现实验室信息、实验教学课程模块、仪器设备管理、耗材试剂管理、实验室资源信息交互等管理业务能力的提升。实验过程实现从业务申请、样品交接、任务分配、实验过程(包括仪器自动采集数据)、报告生成、数据及报告的审核批准、报告签发打印(包括电子签名)等全过程“无纸化”。所有流程中的各环节为计算机操作和监控，提高了实验精度，能够灵活应对数据导入、数据查询、数据分析、报表展示等，并能针对用户的设备对接等个性化需求进行功能的定制开发，满足使用者需求。</p>"
      }],
      // section6列表
      s6list: [{
        subnav: '互联网定制开发',
        sublist: []
      },{
        subnav: '大数据应用服务',
        sublist: []
      },{
        subnav: '智慧城市',
        sublist: []
      }],
      spanShow: [false, false, false, false, false, false, false, false],
      mainShow: [true, false, false, false, false, false, false],


      // section7

      mids: [{
        src: require("../assets/img/icon12.png")
      },{
        src: require("../assets/img/icon1.png")
      },{
        src: require("../assets/img/icon8.png")
      },{
        src: require("../assets/img/icon11.png")
      },{
        src: require("../assets/img/icon5.png")
      },{
        src: require("../assets/img/icon10.png")
      }],
      s7list: [{
        list: [{
          title: "公司简介",
          id: "110",
          ch: "37"
        },{
          title: "领导致辞",
          id: "117",
          ch: "38"
        },{
          title: "企业文化",
          id: "111",
          ch: "39"
        },{
          title: "加入我们"
        }]
      },{
        list: ["互联网定制开发","大数据应用服务","智慧城市"]
      },{
        list: [{
		   title: "亿信云平台",
			 id: 203           
		   },{
			 title: "知识图谱平台",
			 id: 200
		   },{
			 title: "融合通信平台",
			 id: 201
		   },{
			 title: "应急指挥调度平台",
			 id: 206
		   },{
			 title: "新零售系统",
			 id: 207
        }]
      },{
        list: [{
           title: "政务大数据共享交换平台",
             id: 199 
           },{
		     title: "智慧校园管理系统",
             id: 204
           },{
             title: "供应链管理系统",
             id: 205
           },{
			 title: "网站（集群）内容管理系统",
             id: 202 
           },{
             title: "实验室管理系统",
             id: 208
        }]
      },{
        list: ["公司动态","行业热点","公示公告"]
      }]
    }
  },
  methods:{

    // 分屏跳转
    top1(){
      this.$refs.fullpage.api.moveTo("page1", 1);
    },
    top2(){
      this.$refs.fullpage.api.moveTo("page2", 1)
    },
    top3(){
      this.$refs.fullpage.api.moveTo("page3", 1);
    },
    top4(){
      this.$refs.fullpage.api.moveTo("page4", 1);
    },
    top5(){
      this.$refs.fullpage.api.moveTo("page5", 1);
    },
    top6(){
      this.$refs.fullpage.api.moveTo("page6", 1);
    },
    top7(){
      this.$refs.fullpage.api.moveTo("page7", 1);
    },
    art(index){
      if(index == 0){
        return{
          name: 'content',
          params: {
            ch: 24,
            page: '1.html'
          }
        }
      }else if(index == 1){
        return{
          name: 'content',
          params: {
            ch: 25,
            page: '1.html'
          }
        }
      }else if(index == 2){
        return{
          name: 'content',
          params: {
            ch: 26,
            page: '1.html'
          }
        }
      }
    },
    mainshow(index){
      for(let i = 0; i<=6; i++){
        this.$set(this.mainShow, i, false)
      }
      this.$set(this.mainShow, index, true)
    },
    afterLoad: function(origin, destination, direction) {
      if(destination.index == 0){
        this.menushow = 0
      }else if(destination.index == 1){
        this.section2_show = true
        this.menushow = 1
      }else if(destination.index == 2){
        this.menushow = 2
        this.swiper_show = true
        this.t_show = true
      }else if(destination.index == 3){
        this.menushow = 3
        this.s4main = true
        this.s4t = true
      }else if(destination.index == 4){
        this.menushow = 4
        this.s5_show = true
      }else if(destination.index == 5){
        this.menushow = 5
        this.s6_show = true
      }else if(destination.index == 6){
        this.menushow = 6
        this.end = [1000, 1048576, 98, 6781]
      }
    },
    onLeave: function(origin, destination, direction) {
      if(origin.index == 1){
        this.section2_show = false
      }else if(origin.index == 2){
        this.swiper_show = false
        this.t_show = false
      }else if(origin.index == 3){
        this.s4main = false
        this.s4t = false
      }else if(origin.index == 4){
        this.s5_show = false
      }else if(origin.index == 5){
        this.s6_show = false
      }else if(origin.index == 6){
        this.end = [0, 0, 0, 0]
      }
    },
    contentShow: function(index){
      for(let i = 0; i<=9; i++){
        this.$set(this.s5l[i], 'show', false)
      }
      this.$set(this.s5l[index], 'show', true)
    },
    todevelop(index){
      if(index == 0){
        return {
          path: '/develop.html',
        }
      }else if(index == 1){
        return {
          path: '/bigdata.html',
        }
      }else if(index == 2){
        return {
          path: '/city.html',
        }
      }
    },
    guanyu(index){
      if(index == 0){
        return{name: 'article', params: {
          id: 110 + '.html',
          ch: 37
        }}
      }else if(index == 1){
        return{name: 'article', params: {
          id: 117 + '.html',
          ch: 37
        }}
      }else if(index == 2){
        return{path: '/about.html'}
      }else if(index == 3){
        return{path: '/personnel.html'}
      }
    },
    imgTo1(){
      this.bgshow1 = 0
    },
    imgTo2(){
      this.bgshow1 = 1
    },
    imgTo3(){
      this.bgshow1 = 2
    },
    imgTo4(){
      this.bgshow1 = 3
    },
	imgTo5(){
      this.bgshow1 = 4
    },
	imgTo6(){
      this.bgshow1 = 5
    }
  },
  created() {
    setInterval(() => {
      if(this.bgshow1 < 5){
        this.bgshow1++
      }else if(this.bgshow1 == 5){
        this.bgshow1 = 0
      }
    },5000)
    // if(this.$route.query.page == 2){
    //   this.$refs.fullpage.api.moveTo(page, 2);
    // }
    if(document.documentElement.clientWidth <= 768){
        this.swiperOption.slidesPerView = 1
        this.swiperOption.loop =  true,
        this.swiperOption.loop = true
        this.section2_show = true
        this.swiper_show = true
        this.t_show = true
        this.s4main = true
        this.s4t = true
        this.s5_show = true
        this.s6_show = true
        this.$nextTick(function(){
            this.$refs.myswiper.update()
        })
    }
    if(document.documentElement.clientWidth >= 769 && document.documentElement.clientWidth <= 1200){
        this.$set(this.swiperOption, 'slidesPerView', 2)
        this.swiperOption.loop =  true,
        this.section2_show = true
        this.swiper_show = true
        this.t_show = true
        this.s4main = true
        this.s4t = true
        this.s5_show = true
        this.s6_show = true
        this.$nextTick(function(){
            this.$refs.myswiper.update()
        })
    }else if(document.documentElement.clientWidth > 1200){
        this.$set(this.swiperOption, 'slidesPerView', 3)
    }
    news({
      apikey: 123456,
      channel: 24,
      page: 1,
      pagesize: 10
    }).then(res => {
      this.swps = res.data[0]
      for(var i = 0; i<=9; i++){
        this.swps[i].createtime = option.month(this.swps[i].createtime*1000)
      }
    }).catch(err => {
      console.log(err.data)
    })
    news({
      apikey: 123456,
      channel: 34,
      page: 1,
      pagesize: 30,
      orderby: "weigh"
    }).then(res => {
      this.message.msg3 = res.data[0]
    }).catch(err => {
      console.log(err.data)
    })

    news({
      apikey: 123456,
      channel: 33,
      page: 1,
      pagesize: 30,
      orderby: "weigh"
    }).then(res => {
      this.message.msg2 = res.data[0]
    }).catch(err => {
      console.log(err.data)
    })
    news({
      apikey: 123456,
      channel: 32,
      page: 1,
      pagesize: 30,
      orderby: "weigh"
    }).then(res => {
      this.message.msg1 = res.data[0]
      console.log(res.data[0])
    }).catch(err => {
      console.log(err.data)
    })
    news({
      apikey: 123456,
      channel: 43,
      page: 1,
      pagesize: 10
    }).then(res => {
      this.s6list[0].sublist = res.data[0]
      this.s6list[0].sublist.reverse()
      this.s6list[1].sublist = res.data[0]
      this.s6list[1].sublist.reverse()
      this.s6list[2].sublist = res.data[0]
      this.s6list[2].sublist.reverse()
    }).catch(err => {
      console.log(err.data)
    })
  },
  mounted(){

    // window.onresize = () => {
    //   return (() => {
    //     if(document.documentElement.clientWidth <= 1200){
    //         this.$set(this.swiperOption, 'slidesPerView', 2)
    //     }else if(document.documentElement.clientWidth > 1200){
    //         this.$set(this.swiperOption, 'slidesPerView', 3)
    //     }
    //     console.log(this.swiperOption.slidesPerView)
    //   })();
    // };
  },
  computed: {
    // swiper() {
    //   return this.$refs.myswiper.swiper;
    // }
  },
  beforeDestroy() {
  }
  // beforeDestroy: {
  //
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

p.pa {
    line-height: 24px;
}
.scroll {
    background: #e1e1e1;
}
.scroll ul li a img {
    height: 220px !important;
}

/* 视频 */
.close{position: absolute; right: 10px; top: 10px; width: 30px; height: 30px; border-radius: 50%; color: #FFFFFF; z-index: 9000; cursor: pointer; border: 1px solid #fff; transition: all .5s;}
.close::after{content: ""; display: block; width: 20px; height: 1px; background: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) rotate(45deg);}
.close::before{content: ""; display: block; width: 20px; height: 1px; background: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) rotate(-45deg);}
.close:hover{background-color: #fff;}
.close:hover::before{background: #1b4591;}
.close:hover::after{background: #1b4591;}
.head-video{position: fixed; width: 100%; left: 0; top: 0; background: rgba(0, 0, 0, .6); height: 100%; z-index: 1000;}
.videos{position:absolute; height: 70%; width: ; left: 50%; top: 50%; transform: translate(-50%, -50%); border: 1px solid #fff; border-radius: 20px; overflow: hidden;}
#videos{height: 100%;}

/*分屏的菜单控制器样式*/
#menu{position: fixed; z-index: 1000; top:50%; transform: translateY(-50%); right: 30px;}
#menu p{position: relative; left: 4px; top: 4px; display: block; width: 9px; height: 9px; background: #fff; border-radius: 50%;}
#menu li{position: relative; cursor: pointer; display: block; width: 17px; height: 17px;  border-radius: 50%; margin-bottom: 40px; border: 1px solid rgba(0, 0, 0, 0); transition: all .5s;}
#menu li.active{border: 1px solid #fff;}
#menu li:hover{border: 1px solid #fff;}
#menu::after{content: ""; display: block; width: 1px; height: 346px; background: #fff; position: absolute; left: 9px; ; top: 10px; opacity: .4;}
#menu li span{position: absolute; display: none; opacity: 0; right: 24px; top: -5px; color: rgba(255, 255, 255, .4); transition: all .5s;}
#menu li:hover span{display: inline; opacity: 1;}

/* 分屏基础样式设置 */
.section{overflow: hidden;}
.section:nth-child(1){
  position: relative;
  background-color: #000;
}
.img-control{position: absolute; left: 50%; bottom: 30px; transform: translateX(-50%); z-index: 600;}
.img-control li{display: inline-block; position: relative; cursor: pointer; width: 30px; height: 3px; margin-left: 20px; background: rgba(255, 255, 255, .2);}
.imgThis{background: #fff !important;}
.s1-bg{position: absolute; top: 0; left: 0; width: 100%; height: 100%;}
.s1-bg:nth-child(3){background: url(../assets/images/home-page-saas.png) center center; background-size: cover;}
.s1-bg:nth-child(2){background: url(../assets/images/index_banner.png) center center; background-size: cover;}
.s1-bg:nth-child(4){background: url(../assets/images/banner3.png) center center; background-size: cover;}
.s1-bg:nth-child(5){background: url(../assets/images/banner5.jpg) center center; background-size: cover;}
.s1-bg:nth-child(6){background: url(../assets/images/banner2.jpg) center center; background-size: cover;}
.s1-bg:nth-child(7){background: url(../assets/images/banner6.jpg) center center; background-size: cover;}
/* 第一屏 */
.section_word{position: relative; width: 1420px; margin: auto; top: 36%; left: ; transform: translateY(-10%); color: #fff; transition: all .5s ease;}
.section_word h1{font-size: 40px; line-height: 50px; font-weight: normal; padding: 8px 0 30px 0;}
.section_word h2{font-size: 36px; font-weight: normal; line-height: 50px;}
.section_word .en{ font-family: "Georgia",serif !important;}
.section_word1 h1{font-weight: bold; font-size: 48px;}
.section_word1 .en{font-size: 18px; line-height: 30px;}
.section_word1 .zh{font-size: 24px; line-height: 26px; padding: 10px 0 30px 0;}
.section_word div{width: 154px; line-height: 40px; position: relative; cursor: pointer; border-radius: 25px; overflow: hidden; border: 2px solid rgba(255, 255, 255, .6); font-size: 14px; color: rgba(255, 255, 255, .8); text-align: center;}
.section_word > div::after{content: ""; position: absolute; z-index: 0; width: 0; height: 100%; left: 0; top: 0; background: #fff; transition: .5s ease;}
.section_word > div:hover::after{width: 100%;}
.section_word > div:hover span{color: #004A7F;}
.section_word div img,.section_word div span{position: relative; z-index: 2; transition: all .5s ease;}
.section_word div div,.section_word div span{display: inline-block; vertical-align: middle;}
.section_word div div{width: 19px; height: 19px; border-radius: 50%; margin-left: 10px; border: 2px solid #0068ce;}
.section_word div div img{position: relative; top: -10px; left: 2px;}
.section_word3 .en{font-size: 30px; padding: 16px 0 10px 0; letter-spacing: 1px;}
.section_word3 .zh{font-size: 16px; line-height: 24px; }
.section_word2 div img,.section_word3 div img{padding-left: 10px;}
.section_word2 div *,.section_word3 div *{display: inline-block; vertical-align: middle;}
.section_word3 div{margin-top: 66px;}
.section_word2 .en{font-size: 18px; padding: 10px 0 10px 0; letter-spacing: 1px;}
.section_word2 h1{padding-bottom: 50px;}
.section_word2 .zh{font-size: 16px; line-height: 36px; }
.section_word2 div{margin-top: 60px; border-radius: 20px; overflow: hidden;}
.section_word4{text-align: right; padding-right: 60px;}
.section_word4 .margin{float: right; border-radius: 20px; margin-top: 30px; overflow: hidden;}
.section_word4 h1{font-weight: bold; font-size: 48px;}
.section_word4 .zh{font-size: 24px; line-height: 36px;}
.section_word4 .en{font-size: 18px; padding-bottom: 10px;}

/* 第二屏 */
.s2{width: 100%; height: 100%; display: flex;}
.s2-left, .s2-middle, .s2-right{flex: 1; position: relative;}
.s2-left{background: url(../assets/images/left_02.jpg); background-size: cover; background-position: center center;}
.s2-middle{background: url(../assets/images/middle.png); background-size: cover; background-position: center center;}
.s2-right{background: url(../assets/images/right.png); background-size: cover; background-position: center center;}
.s2-lmr h1{font-size: 30px; padding: 60px 0 20px 0; text-align: center; color: #fff;}


/* 第二屏左 */
.s2-icon{width: 92px; height: 92px; margin: auto; overflow: hidden; border-radius: 50%; background: #0062a7;}
.s2-icon img{position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%);}
.s2-left-con{position: absolute; height: 400px; top: 50%; left: 50%; transform: translate(-50%, -50%); transition: all .6s ease;}
.s2-left-con1{width: 221px;}
/* .s2-msg{text-align: center;} */
.s2-msg ul li{display: inline-block; cursor: pointer; margin: 6px 0 0 6px; font-size: 16px; transition: all .5s; padding: 6px 13px; color: #a8bbd9; border: 1px solid #0A173E;}
.s2-msg ul a:nth-child(5n+1) li{background: #0a173e;}
.s2-msg ul li:hover{background: #fff; color: #0a173e;}
.s2-msg ul a:nth-child(5n+1) li:hover{background: #fff; color: #0a173e;}
.video{position: absolute; width: 100%; height: 100%;}
.video img{width: 600px; height: 100%;}

/* 第二屏中 */
.s2-left-con2{width: 280px;}

/* 第二屏右 */
.s2-left-con3{width: 217px;}



/* 第三屏 */
.section3{background: url(../assets/images/section3.png); background-size: cover; background-position: center center;}
.swiper{position: relative; width: 84%; max-width: 1400px; top: 8%; margin: auto;}
.swiper-con{width: 90%; max-width: 420px; margin: auto; height: 466px;}
.swiper-con-main{width: 100%; cursor: pointer; height: 100%; position: relative; top: -76px;}
.line{position: absolute; width: 100%; top: 40.2%; height: 1px; background: #fff; opacity: .2;}
.swiper-img{width: 100%; height: 233px; overflow: hidden; opacity: 0;}
.swiper-img img{height: 100%; width: 100%;}
.swiper-con .swiper-time{text-align: center; font-size: 30px; padding: 24px 0 14px 0; color: #fff;}
.swiper-con .swiper-time::after{content: ""; display: block; width: 35px; height: 3px; margin: auto; background: #fff; margin-top: 10px; }
.swiper-con .swiper-title{display: block; text-align: center; margin: auto; width: 294px; font-size: 16px; padding-bottom: 20px; overflow: hidden; text-overflow:ellipsis; white-space: nowrap; color: #fff;}
.swiper-msg{width: 294px; margin: auto; display: -webkit-box; overflow: hidden; white-space: normal !important; text-overflow: ellipsis; word-wrap: break-word;
    -webkit-line-clamp: 3; -webkit-box-orient: vertical; color: #868686;}
.swiper-con *{transition: all .8s ease;}
.swiper-con:hover .swiper-img{opacity: 1;}
.swiper-con:hover .swiper-con-main{top: 0; background: #fff;}
.swiper-con:hover .swiper-time{color: #333;}
.swiper-con:hover .swiper-time::after{background: #000;}
.swiper-con:hover .swiper-title{color: #333;}
.swiper-con:hover .swiper-msg{color: #333;}
.section3 h1{text-align: center; font-size: 30px; padding-top: 100px; color: #fff;}
.section3 h1::after{content: "NEWS"; font-size: 16px; display: block; text-align: center; font-weight: normal;}
.swiper-next, .swiper-prev{position: absolute; z-index: 2200; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 50%; text-align: center; cursor: pointer; top: 40.2%;
    z-index: 600; color: #fff; background: rgba(255, 255, 255, .1); border: 1px solid #fff; transform: translateY(-50%); outline: none; transition: all .5s ease;}
.swiper-next:hover, .swiper-prev:hover{color: #35495E; background: #0d348d;}
.swiper-prev{left: -68px;}
.swiper-next img{transform: rotate(180deg);}
.swiper-next{right: -68px;}
.s3-more{position: relative; margin: auto; width: 160px; line-height: 40px; margin-top: 5%; border-radius: 20px; overflow: hidden; color: #fff; text-align: center; transition: all .5s ease; border: 1px solid #fff;}
.s3-more::after{content: "MORE VIEW"; color: #000000; overflow: hidden; white-space: nowrap; width: 0; height: 100%; position: absolute; z-index: 0; display: block; background: #fff; left: 0; top: 0; transition: all .5s ease;}
.s3-more:hover::after{width: 100%;}
.mo{position: relative; margin: auto; width: 160px; line-height: 40px; margin-top: 40px; color: #fff; text-align: center; border: 1px solid #fff;}
.mo::after{content: "MORE"; color: #000000; overflow: hidden; white-space: nowrap; width: 0; height: 0; position: absolute; z-index: 0; display: block; background: #fff; left: 0; top: 0; transition: all .5s ease;}
.mo:hover::after{height: 100%; width: 100%}

/* 第四屏 */
.section4{background: url(../assets/images/section4.png); background-position: center center; background-size: cover;}
.section4 h1{text-align: center; font-size: 36px; font-weight: normal; padding-top: 8%; color: #fff;}
.section4 h1::after{content: "借助业界领先的数据、分析和安全运营解决方案，提供与目标数据模型精准匹配的数据源，通过机器学习、自动化和预测性分析提升数据的应用价值。"; font-size: 14px; display: block; line-height: 40px; text-align: center; font-weight: normal; color: #7b7b7b;}
.s4-main{padding-top: 60px;}
.s4-main{width: 1280px; margin: 0 auto; display: flex; justify-content: space-between;}
.s4-submain{width: 360px; height: 491px; position: relative; color: #fff}
.s4-span{position: absolute; bottom: 0; left: 0; right: 0; height: 0; overflow: hidden; box-sizing: border-box; padding: 0 45px 0 45px; transition: all .5s ease;}
.s4-t{text-align: center; font-weight: bold; font-size: 18px; position: relative; line-height: 40px; padding-bottom: 30px;}
.s4-t::after{content: ""; display: block; width: 76px; height: 2px; background: #83C22C; margin: 0 auto;}
.s4-msg{font-size: 14px; line-height: 24px; padding-bottom: 30px;}
.s4-btn{width: 170px; line-height: 32px; cursor: pointer; color: #fff; text-align: center; border: 3px solid #83C22C; margin: 0 auto;}
.s4-submain:nth-child(1){background: url(../assets/images/bigdata1.png) center center; background-size: cover;}
.s4-submain:nth-child(2){background: url(../assets/images/bigdata2.png) center center; background-size: cover;}
.s4-submain:nth-child(3){background: url(../assets/images/bigdata3.png) center center; background-size: cover;}
.s4-bottom{position: absolute; bottom: 0; left: 0; line-height: 68px; opacity: 1; width: 100%; text-align: center; font-weight: bold; color: #fff; transition: all .5s ease;}
.s4-submain:nth-child(1) .s4-bottom{background: rgba(0, 69, 142, .8);}
.s4-submain:nth-child(2) .s4-bottom{background: rgba(132, 194, 37, .8);}
.s4-submain:nth-child(3) .s4-bottom{background: rgba(236, 129, 62, .8); }
.s4-submain:nth-child(1) .s4-span{background: rgba(0, 69, 142, .6);}
.s4-submain:nth-child(2) .s4-span{background: rgba(132, 194, 37, .6);}
.s4-submain:nth-child(3) .s4-span{background: rgba(236, 129, 62, .6);}
.s4-submain:hover .s4-span{height: 100%;}
.s4-submain:hover .s4-bottom{opacity: 0;}
.s4-span-m{position: relative; top: 50%; transform: translateY(-50%);}
.s4-swiper{display: none; width: 360px; margin: 0 auto;}
.swiper-slide:nth-child(1) .s4-submain{background: url(../assets/images/bigdata1.png) center center; background-size: cover;}
.swiper-slide:nth-child(2) .s4-submain{background: url(../assets/images/bigdata2.png) center center; background-size: cover;}
.swiper-slide:nth-child(3) .s4-submain{background: url(../assets/images/bigdata3.png) center center; background-size: cover;}
.swiper-slide:nth-child(4) .s4-submain{background: url(../assets/images/bigdata1.png) center center; background-size: cover;}
.swiper-slide:nth-child(5) .s4-submain{background: url(../assets/images/bigdata2.png) center center; background-size: cover;}
.swiper-slide:nth-child(1) .s4-submain .s4-bottom{background: rgba(0, 69, 142, .8);}
.swiper-slide:nth-child(2) .s4-submain .s4-bottom{background: rgba(132, 194, 37, .8);}
.swiper-slide:nth-child(3) .s4-submain .s4-bottom{background: rgba(236, 129, 62, .8);}
.swiper-slide:nth-child(4) .s4-submain .s4-bottom{background: rgba(0, 69, 142, .8);}
.swiper-slide:nth-child(5) .s4-submain .s4-bottom{background: rgba(132, 194, 37, .8);}
.swiper-slide:nth-child(1) .s4-submain .s4-span{background: rgba(0, 69, 142, .6);}
.swiper-slide:nth-child(2) .s4-submain .s4-span{background: rgba(132, 194, 37, .6);}
.swiper-slide:nth-child(3) .s4-submain .s4-span{background: rgba(236, 129, 62, .6);}
.swiper-slide:nth-child(4) .s4-submain .s4-span{background: rgba(0, 69, 142, .6);}
.swiper-slide:nth-child(5) .s4-submain .s4-span{background: rgba(132, 194, 37, .6);}

/* 第五屏 */
.section5{background: url(../assets/images/section5.png) center center; background-size: cover;}
.s5-nav{width: 285px; display: inline-block; text-align: right; padding: 200px 0 0 0; box-sizing: border-box; font-size: 16px; height: 100%; background: url(../assets/images/b_02.png);}
.s5-nav p{position: relative; font-size: 14px; z-index: 2; line-height: 44px; color: #fff;}
.s5-nav li{padding-right: 40px; position: relative; cursor: pointer;}
.s5-content{width: 1400px; height: 100%; margin: auto; font-size: 0;}
.s5-t h1{font-size: 36px; font-weight: normal;}
.s5-t p{font-size: 16px; padding-top: 15px;}
.s5-main-l, .s5-main-r{display: inline-block; vertical-align: top; position: relative;}
.s5-main-r .img{position: absolute; padding: 200px 0 0 20px;}
.s5-main-l{width: 480px;}
.s5-main{display: inline-block; font-size: 16px; padding: 90px 0 0 120px; white-space: nowrap; box-sizing: border-box; color: #fff; width: 1115px; vertical-align: top;}
.s5-change{position: absolute; padding-top: 50px; width: 480px; white-space: normal;}
.s5-change h3{font-size: 16px; line-height: 60px;}
.s5-change p{font-size: 16px; line-height: 32px;}
.s5c-p >>> p{text-indent: 2em;}
.s5c-p{padding-bottom: 20px;}
.btn1{width: 120px; float: right; line-height: 30px; border-radius: 15px; border: 1px solid #fff; color: #fff; text-align: center; cursor: pointer;}
.btn1 img{padding-left: 10px;}
.s5-nav li::after{content: ""; position: absolute; width: 0; height: 100%; top: 0; left: 0; z-index: 1; background: url(../assets/images/hy_03.jpg) left; transition: all .5s;}
.s5-nav li:hover::after{content: ""; position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: 1; background: url(../assets/images/hy_03.jpg) left;}
.this-nav::after{content: ""; position: absolute; width: 100% !important; height: 100%; top: 0; left: 0; z-index: 1; background: url(../assets/images/hy_03.jpg) left; transition: all .5s;}

/* 第6屏样式 */
.section6{background: url(../assets/images/section6.png) center center; background-size: cover;}
.s6-content{width: 1420px; position: relative; margin: auto; padding-top: 130px;}
.s6-nav{width: 100%; padding: 10px 0 30px 0; height: 40px; border-top: 4px solid #233460; color: #fff;}
.s6-nav h1{font-size: 36px; font-weight: normal; float: left;}
.s6-main{width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; position: absolute;}
.s6-m{position: relative;}
.s6-con{position: relative; z-index: 1; width: 24%; left: 0; overflow: hidden; transition: all .5s ease; overflow: hidden; margin-top: 20px; height: 290px}
.family{display: block; width: 100%; height: 100%; overflow: hidden; position: absolute; left: 0; top: 0;}
.family-hover{z-index: 10 !important;}
.img-msg{position: relative; top: 50%; transform: translateY(-50%);}
.img-msg::after{content: ""; display: block; position: relative; z-index: 10; margin: auto; margin-top: 5px; height: 1px; width: 20%; background-color: #fff; transition: all .8s; }
.img-msg::before{content: ""; display: block; position: relative; z-index: 10; margin: auto; margin-bottom: 5px; height: 1px; width: 20%; background-color: #fff; transition: all .8s}
.sub-nav li{display: inline-block; position: relative; padding-left: 20px;}
.sub-nav li span{position: relative; cursor: pointer;}
.sub-nav li span::after{content: ""; display: block; position: relative; left: 50%; width: 0; height: 2px; margin-top: 5px; background: #fff; transition: all .5s ease-in-out;}
.sub-nav li span:hover::after{width: 100%; left: 0;}
.sub-nav ul{float: right; padding: 20px 30px 0 0;}
.con-img{position: absolute; height: 100%; left: 0;  transition: all .5s ease-in;}
.imghover{height: 110%;}
.s6-con span{position: absolute; width: 100%; opacity: 0; height: 100%; transition: all .5s ease-in; text-align: center; background: rgba(0, 0, 0, .7); color: #fff;}
.s6-con span h3::before{padding-top: 100px;}
.s6-con:hover .con-img{transform: scale(1.05);}
.s6-con:hover span{opacity: 1;}
.s6-con:hover .img-msg::after{width: 4px;}
.s6-con:hover .img-msg::before{width: 4px;}
.span-here::after{content: "" ; display: block; position: relative; left: 0 !important; width: 100% !important; height: 2px; margin-top: 5px; background: #fff;}
.too{position: relative; float: right; width: 140px; border-radius: 20px; overflow: hidden; cursor: pointer; line-height: 34px; top: 10px; left: -4px; color: #fff; text-align: center; border: 1px solid #fff; transition: all .5s ease;}
.too:hover{background-color: #fff; color: #000000;}




/* 第七屏样式 */
.section7{position: relative; background: url(../assets/images/section7.png) center center; background-size: cover;}
.s7-content{width: 1580px; margin: auto; display: flex;}
.s7-top{width: 100%; margin: auto; padding: 100px 0 80px 0; background: url(../assets/images/footer_im.jpg) center center;}
.s7t-con{width: 25%; text-align: center;}
.s7-top *,.s7t-middle *,.s7t-bottom *{position: relative; z-index: 10;}
.tb{position: relative; height: 100%;}
.tb-span{position: absolute; width: 100%; height: 100%; background-color: #0d162e; opacity: .4;}
.s7t-all{padding-bottom: 200px; background: url(../assets/images/footbg2.png) center center;}
.s7t-middle h3{text-align: center; color: #d0d4f5; font-size: 30px; line-height: 100px; font-weight: normal;}
.s7t-middle{width: 1480px; position: relative; padding: 30px 0 40px 0; margin: auto;}
.s7t-middle::after{content: ""; position: absolute; display: block; width: 200%; height: 1px; background: #fff; opacity: .1; left: -900px; bottom: 0;}
.sub-middle{width: 100%; display: flex; flex-wrap: wrap;}
.mid-con{width: 16.6%; height: 68px;}
.mid-con img{display: block; position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%); transition: all .5s ease-in-out;}
.mid-con img:hover{ filter: drop-shadow(0 0 10px #000) brightness(200%);}
.s7t-bottom{width: 1360px; padding-top: 40px; margin: auto; display: flex; color: #fff;}
.bot-con{flex: 1; box-sizing: border-box;}
.bot-con h5,.bot-con2 h5,.bot-con6 h5{font-size: 16px;}
.bot-con p,.bot-con2 p,.bot-con6 p{font-size: 14px; margin-top: 10px; color: #999999}
.bot-con3{flex: 1;}
.bot-con2{flex: .6;}
.bot-con2 h5 img{position: relative;top: 2px; padding: 0 10px 0 0;}
.bot-con h5,.bot-con2 h5,.bot-con3 h5{font-size: 16px; cursor: pointer;}
.bot-con p,.bot-con3 p,.bot-con2 p{font-size: 14px; margin-top: 10px; color: #999999}
.p1{font-size: 16px !important;}
.ewm{padding-top: 10px;}
.s7t-con span{font-size: 48px; color: #fff;}
.s7t-con img{display: inline-block; vertical-align: middle;}
.s7t-con-r{display: inline-block; vertical-align: middle; padding-left: 10px; text-align: center;}
.s7t-con-r p{font-size: 16px; color: #fff;}
.s7-footer{position: absolute; bottom: 0; width: 100%; line-height: 32px; font-size: 12px; text-align: center; color: #989898; background: #333333;}
.s7-footer *{display: inline-block; vertical-align: middle;}
.wechat{width: 109px; padding-top: 10px;}
.bot-con3-m{display: none;}
.s7t-bottom p span{cursor: pointer; color: #989898;}
.s7t-bottom h5{color: #fff;}
.s7t-bottom p span:hover{color: #fff;}


/* 动画定义 */
.video-enter-active { transition: all .5s ease;}
.video-leave-active { transition: all .5s ease;}
.video-enter, .video-leave-to{opacity: 0;}

.img-enter-active { transition: all 1s ease-in-out;}
.img-leave-active { transition: all 1s ease-in-out;}
.img-enter, .img-leave-to{opacity: 0;}

.s4_span-enter-active { transition: all 1s ease-in-out;}
.s4_span-leave-active { transition: all 1s ease-in-out;}
.s4_span-enter, .s4_span-leave-to{width: 0; webkit-transform: translateZ(0); -moz-transform: translateZ(0); -ms-transform: translateZ(0); -o-transform: translateZ(0); transform: translateZ(0);}

.section2-enter-active { transition: all .8s ease-in-out;}
.section2-leave-active { transition: all .8s ease-in-out;}
.section2-enter, .section2-leave-to{top: 600px; opacity: 0;}

.s3_title-enter-active { transition: all 1s ease-in-out;}
.s3_title-leave-active { transition: all 1s ease-in-out;}
.s3_title-enter, .s3_title-leave-to{transform: translateY(100px); opacity: 0;}

.s3_swiper-enter-active { transition: all 1.5s ease-in-out;}
.s3_swiper-leave-active { transition: all 1.5s ease-in-out;}
.s3_swiper-enter, .s3_swiper-leave-to{transform: translateY(100px); opacity: 0;}

.fade-enter-active { transition: all .8s ease;}
.fade-leave-active { transition: all .8s ease;}
.fade-enter, .fade-leave-to{transform: translateY(100px); opacity: 0;}

.fader-enter-active { transition: all .8s ease-in-out;}
.fader-leave-active { transition: all .8s ease-in-out;}
.fader-enter, .fader-leave-to{transform: translateY(-100px); opacity: 0;}

.s6_fade-enter-active { transition: all 1s ; transition-delay: 1s;}
.s6_fade-leave-active { transition: all 1s ;}
.s6_fade-enter, .s6_fade-leave-to{width: 0; webkit-transform: translateZ(0); -moz-transform: translateZ(0); -ms-transform: translateZ(0); -o-transform: translateZ(0); transform: translateZ(0);}

.vides-enter-active { animation: videos 1s; }
.vides-leave-active { animation: videoss 1s;}


/* 手机 */
.s2-swiper{display: none;}
.s2-pagination{text-align: center; position: absolute; z-index: 6; bottom: 30px; width: 100%; display: none;}
#s2-pagination >>> .s2-bull{display: inline-block; width: 24px; margin: 0 0 0 4px; height: 3px; background: #8c95aa;}
#s2-pagination >>> .s2-active{background: #fff !important;}

.s4nt, .s4pr{position: absolute; font-family: '宋体' !important; z-index: 1000; outline: none; width: 24px; height: 40px; text-align: center; color: #fff; background: #004A7F; top: 50%; transform: translateY(-50%);}
.s4-swiper{position: relative;}
.s4nt{right: 16px; background: url(../assets/images/next.png) no-repeat; background-size: 100% 100%;}
.s4pr{left: 16px; background: url(../assets/images/prev.png) no-repeat; background-size: 100% 100%;}


.s5-m-content{display: none; padding: 60px 0 60px 0;}
.s5-m-msg{position: relative; width: 76%; font-size: 14px; line-height: 26px; margin: 0 auto;  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  height:182px;}
.s5-m-con{color: #fff;}
.s5-pagination{text-align: center; }
#s5-pagination >>> .s5-bull{display: inline-block; width: 24px; margin: 0 0 0 4px; height: 3px; background: #8c95aa;}
#s5-pagination >>> .s5-active{background: #fff !important;}
.s5-m-con .s5-img{position: absolute; height: 240px; opacity: .2; z-index: 0; left: 50%; transform: translateX(-50%);}
.s5-m-con h3{display: block; font-size: 16px; width: 76%; margin: 0 auto; padding: 20px 0 20px 0;}
.s5-m-title h2{text-align: center; color: #fff;}

.s6-m-content{display: none; padding: 70px 0 40px 0;}
.s6-m-content h2{padding-bottom: 20px;}
.s6-btn{padding-top: 10px;}
.s6-m-c{width: 90%; margin: 0 auto; display: flex; flex-wrap: wrap; justify-content: space-between;}
.s6-m-con{position: relative; width: 48%; padding-top: 10px;}
.s6-m-con img{width: 100%;}


@keyframes videos{
  0%{
    transform: rotate(0deg) scale(0);
  }
  50%{
    transform: rotate(10deg) scale(0.7);
  }
  100%{
    transform: rotate(0deg) scale(1);
  }
}

@keyframes videoss{
  0%{
    transform: rotate(0deg) scale(1);
  }
  50%{
    transform: rotate(10deg) scale(0.7);
  }
  100%{
    transform: rotate(0deg) scale(0);
  }
}



@media screen and (max-height: 480px) {
  .section_word{top: 50%;}
}
@media screen and (max-height: 860px) {
  .s6-con{height: 230px;}

  /* 第七屏 */
  .s7t-middle{padding-top: 10px;}
  .s7t-bottom{padding-top: 10px;}
}

@media screen and (max-width: 480px) {
  .section_word h1{font-size: 26px;}
}


@media screen and (max-width: 997px){
  .sub-nav li{font-size: 14px; padding-left: 10px;}
  .s6-nav h1{font-size: 28px; padding-top: 4px;}
  .s6-con{height: 208px;}
}
@media screen and (max-width: 1023px){
  .section{height: 900px;}
  .here{width: 100% !important;}
  .section4{height: 1200px;}

}
@media screen and (max-width: 919px) {
  .s4-submain{display: none;}
  .s4-swiper{display: block;}
  .s4-swiper .s4-submain{display: block !important;}
  .s4-span{height: 100% !important;}
  .s4-submain:hover .s4-span{height: 100% !important;}
  .s4-t{font-size: 16px; padding-bottom: 10px;}
  .s4-msg{font-size: 12px; padding-bottom: 10px;}
  .s4-btn{width: 136px; line-height: 30px; font-size: 14px; color: #fff;}
}
@media screen and (min-width: 920px) and (max-width: 1280px){
  .s4-main{width: 900px;}
  .s4-submain{width: 270px; height: 400px;}
  .s4-t{font-size: 16px; padding-bottom: 10px;}
  .s4-msg{font-size: 12px; padding-bottom: 10px;}
  .s4-btn{width: 136px; line-height: 30px; font-size: 14px;}
}
@media screen and (min-width: 769px) and (max-width: 1200px){
  .swiper{width: 600px !important;}
}
@media screen and (max-width: 1200px) {
  #menu{display: none;}
  .s2{flex-direction: column;}
  .s2-icon{display: none;}
  .s2-left-con{height: 200px; width: 600px;}
  .s2-left-con2, .s2-left-con3{height: 300px}
  .s2-left-con2 .s2-msg ul li:nth-child(6){display: none;}
  .s3-pagination{text-align: center; }
  #s3-pagination >>> .s3-bull{display: inline-block; width: 24px; margin: 0 0 0 4px; height: 3px; background: #8c95aa;}
  #s3-pagination >>> .s3-active{background: #fff !important;}


  .icon img{width: 60px;}

  .btn{width: 100px;}
  .swiper-con-main{top: -54px !important;}
  .swiper-con:hover .swiper-con-main{top: 26px !important; background: #fff;}
  .swiper-title{font-size: 14px;}
  .swiper-msg{font-size: 12px;}
  .swiper-con .swiper-time{padding: 14px 0 10px 0;}
  .swiper-con{height: 360px;}
  .s5-main{width: 700px; padding: 90px 0 0 80px;}
  .s5-content{width: 1024px;}
  .s5-main-r .img{display: none;}
  .s5-main{width: 480px !important;}
  .s5-content{width: 780px !important;}
  .fp-tableCell{height: auto !important; }
  .s6-con{height: 232px;}
  .swiper-img{height: 170px !important; overflow: hidden;}
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .swiper-con-main{top: -80px !important;}
}



@media screen and (max-width: 1560px) {
  .section_word{width: 90%;}
  .s6-content{width: 90%;}
  .swiper{width: 1000px;}
  .swiper-msg{width: 200px;}
  .swiper-con .swiper-title{width: 200px;}
  .swiper-img{height: auto;}
  .swiper-con{height: 400px;}
  .swiper-con-main{top: -60px;}
  .swiper-img{height: 184px; overflow: hidden;}

  /* 第七屏 */
  .s7t-con span{font-size: 30px;}
  .s7t-middle{width: 1200px;}
  .s7t-bottom{width: 1140px;}
  .bot-con6{flex: 5;}
  .s7-content{width: 1200px;}
}
@media screen and (max-width: 1440px) {
  .s5-main{width: 900px; padding: 90px 0 0 40px;}
  .s5-content{width: 1200px;}
  .s5-main-r .img img{width: 400px;}
  .s6-con{height: 230px;}

  /* 第七屏 */
  .s7t-middle{width: 100% !important; padding: 40px 123px 30px 123px !important; box-sizing: border-box;}
  /* .s7t-con{text-align: left;} */
  .s7t-con img{width: 60px;}
  .s7t-con span{font-size: 24px;}
  .s7t-con-r p{font-size: 12px;}
  .s7t-bottom{width: 100%; padding: 40px 133px 0 133px; box-sizing: border-box;}
  .s7-content{width: 100%; padding: 30px 80px 0 80px; box-sizing: border-box;}
}

@media screen and (max-width: 1440px){
  .s3-more{margin: auto; margin-top: 10px;}
  .s3 h1{padding-top: 100px;}

  .swiper-con:hover .swiper-con-main{top: -6px !important;}

  /* 第七屏 */
  .s7-content{padding: 0px 80px 0 80px; }
  .s7-top{padding: 100px 0 20px 0;}

  .bo1{display: none;}
  .s7t-con img{width: 60px;}
  .s7t-con-r span{font-size: 28px;}
  .s7t-con-r p{font-size: 14px;}
  .s7t-middle h3{font-size: 26px; line-height: 60px;}
  .s7t-middle{ padding-top: 0 !important; padding-bottom: 0 !important;}
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .s7-content{width: 100%}
  .s7t-con img{display: none;}
  .s7-top{width: 100%;}
  .s7t-con{width: 25%;}
  .bot-con{flex: .6;}
  .mid-con{width: 33.33%;}
  .s7t-con span{font-size: 30px;}
  .bot-con6{flex: 5;}
  .s7t-bottom{width: 100%;}
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .s7-content{width: 100%}
  .s7-top{width: 100%;}
  .s7t-con{width: 25%;}
  .bot-con{flex: .5;}
  .bo{flex: .8;}
  .bot-con3{flex: .9;}
  .bot-con2{display: none;}
  .s7t-con img{display: none;}
  .s7t-con span{font-size: 30px;}
  .mid-con{width: 33.33%;}
  .bot-con {padding: 0;}
  .s7t-bottom{width: 100%; padding-top: 10px; box-sizing: border-box;}
}
@media screen and (max-width: 768px) {
  .videos{position:absolute; width: 100%; width: ; left: 50%; top: 50%; transform: translate(-50%, -50%); border: none; border-radius: 20px; overflow: hidden;}
  #videos{width: 100%; height: 100%;}

  .section{height: auto !important;}

  .section1{height: 660px !important; }
  .s1-bg{width: 100%; height: 660px;}
  .s1-bg:nth-child(2){background: url(../assets/images/index_banner.png) center center; background-size: cover;}
  .s1-bg:nth-child(3){background: url(../assets/images/s1m3.png) center center; background-size: cover;}
  .s1-bg:nth-child(4){background: url(../assets/images/s1m1.png) center center; background-size: cover;}
  .s1-bg:nth-child(5){background: url(../assets/images/s1m2.png) center center; background-size: cover;}
  
  .section_word{top: 66% !important; width: 100%;}
  .section_word2{ text-align: center;}
  .section_word h2{font-size: 16px !important; line-height: 20px;}
  .section_word2 h1{font-size: 16px !important; line-height: 20px; padding-bottom: 10px;}
  .section_word2 .zh{display: none;}
  .section_word2 .en{font-size: 12px; padding-top: 0; line-height: 20px;}
  .section_word2 div{margin: 0 auto;}
  .section_word div{width: 40%; line-height: 30px;}
  .section_word3{width: 90%; margin: 0 auto;}
  .section_word3 h1, .section_word3 h2{ font-size: 16px; line-height: 20px; padding-bottom: 4px;}
  .section_word3 .en{font-size: 14px; padding: 0 0 10px 0; line-height: 20px;}
  .section_word3 .zh{font-size: 10px; line-height: 20px;}
  .section_word3 .zh:nth-child(2){padding-bottom: 10px;}
  .section_word3 div{margin: 0; margin-top: 10px;}
  .section_word1{width: 90%; margin: 0 auto;}
  .section_word1 h1, .section_word1 h2{font-size: 16px; padding-bottom: 0; line-height: 30px;}
  .section_word1 h1{padding-top: 4px;}
  .section_word1 .en{font-size: 12px; padding-top: 0; line-height: 20px;}
  .section_word1 .zh{font-size: 10px; line-height: 20px; padding-bottom: 10px;}
  .section_word1 div{margin: 0;}
  .img-control{display: none;}
  .section_word4{text-align: right; box-sizing: border-box; padding-right: 20px; top: 26% !important;}
  .section_word4 .margin{float: right; border-radius: 20px; margin-top: 30px; overflow: hidden;}
  .section_word4 h1{font-weight: bold; padding-bottom: 10px; font-size: 18px;}
  .section_word4 .zh{font-size: 14px; line-height: 36px;}
  .section_word4 .en{font-size: 12px; padding-bottom: 10px}
  .section_word div div img{top: -5px;}


  .s2-swiper{display: block; position: relative;}
  .s2-pagination{display: block;}
  .s2{display: none;}
  .s2-icon{display: block !important; width: 80px; height: 80px;}
  .s2-m-con{padding: 100px 0 100px 0; min-height: 390px;}
  .s2-msg{padding: 0 10% 0 10%; text-align: center;}
  .s2-m-con1 .s2-msg,.s2-m-con3 .s2-msg{padding: 0 15% 0 15%;}
  .s2-msg li{}
  .s2-m-con h1{text-align: center; font-size: 18px; font-weight: normal; padding: 40px 0 20px 0; color: #fff;}
  .s2-m-con1{background: url(../assets/images/left_02.jpg) center center; background-size: cover;}
  .s2-m-con2{background: url(../assets/images/middle.png) center center; background-size: cover;}
  .s2-m-con3{background: url(../assets/images/right.png) center center; background-size: cover;}

  .section3{padding-bottom: 60px;}
  .section3 h1{font-size: 20px; padding: 60px 0 40px 0;}
  .swiper-next{display: none;}
  .swiper-prev{display: none;}
  .swiper-con-main{top: 0 !important; background: #fff;}
  .swiper-con-main *{opacity: 1; color: #333 !important;}
  .swiper-msg{display: none;}
  .swiper-img{height: 190px !important;}
  .swiper-con{height: 300px; width: 90%;}
  .swiper-time{font-size: 22px !important;}
  .swiper{width: 100% !important;}
  .swiper-con .swiper-time::after{background: #7d7d7d;}
  .s3-more{line-height: 30px; font-size: 14px;}


  .section4 h1{font-size: 30px; padding-top: 60px;}
  .section4 h1::after{content: "量身定制 满足各行业不同阶段的大数据需求"; font-size: 12px;}
  .section4{padding-bottom: 40px;}

  .s5-content{display: none;}
  .s5-m-content{display: block;}
  .btn1{position: relative; width: 30%; font-size: 14px; line-height: 26px; margin: 0 auto; float: none; color: #cfcfcf;}
  .s5-m-title{text-align: center;}
  .s5-m-title{padding: 20px 0 40px 0;}
  .s5-m-title p{font-size: 12px; padding-top: 10px; color: #fff;}
  .s5-m-title h2{font-size: 30px; font-weight: normal;}
  .s5-btn{padding: 40px 0 40px 0;}



  .s6-content{display: none;}
  .s6-m-content{display: block;}
  .s6-m-content h2{text-align: center; color: #fff; font-size: 22px; font-weight: normal;}
  .too{float: none; margin: 0 auto; width: 40%; line-height: 26px; font-size: 12px; color: #cbcbcb;}




  .section7 .mid-con:nth-child(n+5){display: none;}
  .section7 .mid-con{width: 25% !important;}
  .section7 .mid-con img{width: 80%;}
  .s7-top{display: none;}
  .section7 .sub-middle{display: flex; width: 100%;}
  .s7t-middle{width: 100% !important; height: 160px; padding: 0 !important;}
  .s7t-middle h3{font-size: 20px;}
  .s7t-bottom{width: 100%;padding: 0; padding-left: 6%;  box-sizing: border-box;}
  .s7t-bottom h5{font-weight: normal; font-size: 14px;}
  .s7t-bottom .bo{display: none;}
  .s7t-bottom .bot-con2{display: none;}
  .s7-footer{position: relative;}
  .bot-con p{font-size: 12px;}
  .bot-con:nth-child(1){flex: .8;}
  .bot-con3-m{display: block;}
  .bot-con3 p{font-size: 12px;  margin: 0; padding-top: 10px;}
  .bot-con3{flex: 1.8;}
  .bot-con3 p:last-child{display: none;}
  .none{display: none;}

  .swiper{width: 90% !important;}
  .s6-con{width: 32%; height: 260px;}
  .s6-con :nth-child(8){display: none;}
  .s4-swiper{width: 100%;}
  .s4-submain{width: 70% !important; height: 400px; margin: auto;}
  .s4-span{width: 100%; padding: 0 30px 0 30px;}


  .s7-footer{line-height: 22px; padding: 10px 0 10px 0;}
  .s7t-all{padding-bottom: 30px !important;}
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue